<template>
  <div ref="layout" class="page-form page-base">
    <h3 class="title">销售计划新增单（公司/营销单元）</h3>

    <div class="form-container">
      <div class="tools">
        <form-button @click="$router.go(-1)">返回</form-button>
      </div>
      <el-form
        ref="form"
        :show-message="false"
        inline
        size="mini"
        disabled
        label-width="100px"
        :model="conditions"
      >
        <common-title title="基本信息" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="销售计划单号">
              <el-input v-model="conditions.plan_order" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="单据类型">
              <el-input value="销售计划新增单（公司/营销单元）" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="销售计划编号">
              <el-input v-model="conditions.plan_number" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="sal_center" class="line-16" label="">
              <template #label>
                公司/营销单元
              </template>
              <el-select v-model="conditions.sal_center" placeholder="">
                <el-option
                  v-for="item in saleList"
                  :key="item.SOBID"
                  :value="item.SOBID"
                  :label="item.MC_SHORT"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="wlybrand" label="存货分类">
              <el-select v-model="conditions.wlybrand" placeholder="">
                <el-option
                  v-for="item in selectDataOptions['A0019']"
                  :key="item.value"
                  :value="item.value"
                  :label="item.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="gjahr" label="年度">
              <el-date-picker
                v-model="conditions.gjahr"
                type="year"
                format="yyyy"
                value-format="yyyy"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :lg="8" :md="24">
            <common-title title="计划量" />
            <el-row>
              <el-col>
                <el-form-item label="初始计划量(吨)" class="line-16" prop="initplan_qty">
                  <el-input v-model.number="conditions.initplan_qty" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :lg="8" :md="24">
            <common-title title="计划额（参考）" />
            <el-row>
              <el-col>
                <el-form-item label="初始计划额(万元)" class="line-16" prop="initplan_amt">
                  <el-input v-model.number="conditions.initplan_amt" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <common-title title="状态" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="24">
            <el-form-item label="备注">
              <el-input v-model="conditions.remark" type="textarea" rows="4" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon title="状态变更记录" :custome-config="() => vxeShowCustom('xTable')">
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        />
      </TableCommon>
    </div>
  </div>
</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { getSalePlanCompnayByNumber } from '@/api/sap/sale-plan'
import { apiGetOrgOrBase } from '@/api/sap/common-sap'

export default {
  data() {
    return {
      loading: false,
      saleList: [],
      conditions: {
        plan_order: '',
        plan_number: '',
        gjahr: '',
        wlybrand: '',
        sal_center: '',
        order_type: 'ZP03',
        initplan_qty: '',
        initplan_amt: '',
        remark: '',
        porder_status: 'E001'
      },
      gridOptions: {
        data: [],
        columns: [
          { field: 'operationer', title: '操作员' },
          { field: 'oper_name', title: '操作员姓名' },
          { field: 'oper_status_text', title: '操作状态' },
          { field: 'changin_date', title: '变更日期' },
          { field: 'changin_time', title: '变更时间' }
        ]
      },
      selectDataOptions: {}
    }
  },
  created() {
    // 存货分类
    this.getSelectDictDataOrigin('A0019')
    apiGetOrgOrBase('', 0).then(res => {
      this.saleList = res.DATA
    })
    this.salePlanCountFindById()
  },
  methods: {
    async salePlanCountFindById() {
      const { data } = await getSalePlanCompnayByNumber({ plan_order: this.$route.query.order })
      Object.assign(this.conditions, data.ls_head || {})
      this.gridOptions.data = data.lt_chg_history || []
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.layout {
  padding: 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/sale-plan-manage/components/salePlanCompanyCheck.vue